module.exports = __webpack_public_path__ + "static/media/nauman.929ab7c8.png";